module.exports = __webpack_public_path__ + "img/arrow-slider-preview.93a1f6a0.svg";